<template>
  <div class="home-v2">
    <GlobalLoading
      v-if="
        $store.state.modalStore.isGlobalLoading || $store.state.level1.isLoading
      "
    />
    <transition name="fade">
      <div class="modal-level2-container">
        <div class="modal-level2-dialog">
          <div class="modal-level2-content">
            <div class="modal-level2-body">
              <!-- <div class="modal-button-close">
                <i class="far fa-times-circle" @click="closeModal()"></i>
              </div> -->
              <Level2 />
            </div>
          </div>
        </div>
      </div>
    </transition>
    <NewVendor v-show="$store.state.modalStore.showNewVendor" />
    <KbliModalFilter v-if="$store.state.searchStore.modalKbliFilter" />
  </div>
</template>
<script>
import axios from 'axios'
import { api } from '@/services/config'
export default {
  name: 'level1',
  components: {
    Level2: () => import('@/views/NewTab/Level2.vue'),
    NewVendor: () => import('@/components/modal/newVendor.vue'),
    KbliModalFilter: () => import('@/components/modal/KbliModalFilter.vue'),
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
  },
  data() {
    return {
      isModalVisible: false,
      modes: [5, 10, 15, 20, 25],
      k3lCategories: null,
      kplhCategories: null,

      listData: [
        {
          logo: '',
          name: 'PRATAMA GRAHA SEMESTA',
          type: 'PT',
          affiliate: true,
          city: 'Jakarta Pusat',
          server: ['SAP', 'ARIBA', 'BCE', 'GEMS', 'BKES'],
          kPO: 5,
          kKontrak: 5,
          k3lScore: '85 High A',
          kplhScore: '75 Medium B1',
          totalEvent: '05 Event',
        },
        {
          logo: '',
          name: 'PRATAMA GRAHA SEMESTA',
          type: 'PT',
          affiliate: true,
          city: 'Jakarta Pusat',
          server: ['SAP', 'ARIBA', 'BCE', 'GEMS', 'BKES'],
          kPO: 5,
          kKontrak: 5,
          k3lScore: '85 High A',
          kplhScore: '75 Medium B1',
          totalEvent: '05 Event',
        },
        {
          logo: '',
          name: 'PRATAMA GRAHA SEMESTA',
          type: 'PT',
          affiliate: true,
          city: 'Jakarta Pusat',
          server: ['SAP', 'ARIBA', 'BCE', 'GEMS', 'BKES'],
          kPO: 5,
          kKontrak: 5,
          k3lScore: '85 High A',
          kplhScore: '75 Medium B1',
          totalEvent: '05 Event',
        },
        {
          logo: '',
          name: 'PRATAMA GRAHA SEMESTA',
          type: 'PT',
          affiliate: true,
          city: 'Jakarta Pusat',
          server: ['SAP', 'ARIBA', 'BCE', 'GEMS', 'BKES'],
          kPO: 5,
          kKontrak: 5,
          k3lScore: '85 High A',
          kplhScore: '75 Medium B1',
          totalEvent: '05 Event',
        },
        {
          logo: '',
          name: 'PRATAMA GRAHA SEMESTA',
          type: 'PT',
          affiliate: true,
          city: 'Jakarta Pusat',
          server: ['SAP', 'ARIBA', 'BCE', 'GEMS', 'BKES'],
          kPO: 5,
          kKontrak: 5,
          k3lScore: '85 High A',
          kplhScore: '75 Medium B1',
          totalEvent: '05 Event',
        },
        {
          logo: '',
          name: 'PRATAMA GRAHA SEMESTA',
          type: 'PT',
          affiliate: true,
          city: 'Jakarta Pusat',
          server: ['SAP', 'ARIBA', 'BCE', 'GEMS', 'BKES'],
          kPO: 5,
          kKontrak: 5,
          k3lScore: '85 High A',
          kplhScore: '75 Medium B1',
          totalEvent: '05 Event',
        },
        {
          logo: '',
          name: 'PRATAMA GRAHA SEMESTA',
          type: 'PT',
          affiliate: true,
          city: 'Jakarta Pusat',
          server: ['SAP', 'ARIBA', 'BCE', 'GEMS', 'BKES'],
          kPO: 5,
          kKontrak: 5,
          k3lScore: '85 High A',
          kplhScore: '75 Medium B1',
          totalEvent: '05 Event',
        },
        {
          logo: '',
          name: 'PRATAMA GRAHA SEMESTA',
          type: 'PT',
          affiliate: true,
          city: 'Jakarta Pusat',
          server: ['SAP', 'ARIBA', 'BCE', 'GEMS', 'BKES'],
          kPO: 5,
          kKontrak: 5,
          k3lScore: '85 High A',
          kplhScore: '75 Medium B1',
          totalEvent: '05 Event',
        },
        {
          logo: '',
          name: 'PRATAMA GRAHA SEMESTA',
          type: 'PT',
          affiliate: true,
          city: 'Jakarta Pusat',
          server: ['SAP', 'ARIBA', 'BCE', 'GEMS', 'BKES'],
          kPO: 5,
          kKontrak: 5,
          k3lScore: '85 High A',
          kplhScore: '75 Medium B1',
          totalEvent: '05 Event',
        },
        {
          logo: '',
          name: 'RIFKY KURNIAWAN',
          type: 'Perorangan',
          affiliate: false,
          city: 'Jakarta Pusat',
          server: ['SAP', 'ARIBA', 'BCE', 'GEMS', 'BKES'],
          kPO: 5,
          kKontrak: 5,
          k3lScore: '85 High A',
          kplhScore: '75 Medium B1',
          totalEvent: '05 Event',
        },
      ],
      leftFilters: [
        {
          title: 'Periode PO',
          type: 'radio',
          filters: [
            {
              name: '6 Bulan',
              value: '6',
            },
            {
              name: '12 Bulan',
              value: '12',
            },
            {
              name: '24 Bulan',
              value: '24',
            },
          ],
        },
        {
          title: 'Periode Event',
          type: 'radio',
          filters: [
            {
              name: '6 Bulan',
              value: '6',
            },
            {
              name: '12 Bulan',
              value: '12',
            },
            {
              name: '24 Bulan',
              value: '24',
            },
          ],
        },
      ],
      sub: [
        {
          code: '00111',
          subName: 'Sub kategori 1',
        },
        {
          code: '00111',
          subName: 'Sub kategori 1',
        },
        {
          code: '00111',
          subName: 'Sub kategori 1',
        },
      ],
    }
  },
  computed: {
    totalItems() {
      return this.$store.state.level1.totalItems
    },
    perPage: {
      get: function() {
        return this.$store.state.level1.perPage
      },
      set: function(newValue) {
        this.$store.dispatch('level1/setLevel1PerPage', newValue)
      },
    },
    currentPage: {
      get: function() {
        return this.$store.state.level1.page
      },
      set: async function(newValue) {
        await this.$store.dispatch('level1/setLevel1Page', newValue)
        await this.$store.commit('level1/SET_DATA_LEVEL1')
      },
    },
    k3lCriteria: async function() {
      return this.getK3lCriteria()
    },
    kplhCriteria: async function() {
      return this.getKplhCriteria()
    },
    choosedCountry: {
      get: function() {
        return this.$store.state.searchStore.choosedCountry
      },
      set: async function(newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosedCountry',
          value: newValue,
        })

        let query = {
          negara: `&negara_id=${newValue}`,
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
    choosedProvince: {
      get: function() {
        return this.$store.state.searchStore.choosedProvince
      },
      set: async function(newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosedProvince',
          value: newValue,
        })

        let query = {
          prov: `&provinsi_id=${newValue}`,
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
    choosedCity: {
      get: function() {
        return this.$store.state.searchStore.choosedCity
      },
      set: async function(newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosedCity',
          value: newValue,
        })

        let query = {
          kota: `&kota_id=${newValue}`,
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
    choosePeriodePO: {
      get: function() {
        return this.$store.state.searchStore.choosePeriodePO
      },
      set: async function(newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'poStartDate',
          value: this.monthFromNow(newValue),
        })
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'poEndDate',
          value: this.$now(),
        })
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosePeriodePO',
          value: newValue,
        })

        let query = {
          poStart: `&po_start_date=${this.monthFromNow(newValue)}`,
          poEnd: `&po_end_date=${this.$now()}`,
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
    choosePeriodeEvent: {
      get: function() {
        return this.$store.state.searchStore.choosePeriodeEvent
      },
      set: async function(newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'eventStartDate',
          value: this.monthFromNow(newValue),
        })
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'eventEndDate',
          value: this.$now(),
        })
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosePeriodeEvent',
          value: newValue,
        })

        let query = {
          eventStart: `&event_start_date=${this.monthFromNow(newValue)}`,
          eventEnd: `&event_end_date=${this.$now()}`,
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
    chooseK3lScore: {
      get: function() {
        return this.$store.state.searchStore.chooseK3lScore
      },
      set: async function(newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'chooseK3lScore',
          value: newValue,
        })

        let query = {
          k3lScore:
            newValue.length > 0
              ? this.paramsFormatter('k3l_score', newValue)
              : '',
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
    chooseKplhScore: {
      get: function() {
        return this.$store.state.searchStore.chooseKplhScore
      },
      set: async function(newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'chooseKplhScore',
          value: newValue,
        })

        let query = {
          kplhScore:
            newValue.length > 0
              ? this.paramsFormatter('kplh_score', newValue)
              : '',
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
    chooseMine: {
      get: function() {
        return this.$store.state.searchStore.chooseMine
      },
      set: async function(newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'chooseMine',
          value: newValue,
        })

        let query = {
          tambang: `&pertambangan_inti=${newValue}`,
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
    chooseSio: {
      get: function() {
        return this.$store.state.searchStore.chooseSio
      },
      set: async function(newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'chooseSio',
          value: newValue,
        })

        let query = {
          sio: `&sio=${newValue}`,
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
    chooseStatus: {
      get: function() {
        return this.$store.state.searchStore.chooseStatus
      },
      set: async function(newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'chooseStatus',
          value: newValue,
        })

        let query = {
          sio: `&status=${newValue}`,
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
    choosePraqualifikasiK3l: {
      get: function() {
        return this.$store.state.searchStore.choosePraqualifikasiK3l
      },
      set: async function(newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosePraqualifikasiK3l',
          value: newValue,
        })

        let query = {
          k3l: newValue ? '&k3l=1' : '',
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
    choosePraqualifikasiKplh: {
      get: function() {
        return this.$store.state.searchStore.choosePraqualifikasiKplh
      },
      set: async function(newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosePraqualifikasiKplh',
          value: newValue,
        })

        let query = {
          kplh: newValue ? '&kplh=1' : '',
        }

        await this.$store.commit('level1/SET_DATA_LEVEL1', { query })
      },
    },
  },
  methods: {
    kbliFilterDetail() {
      this.$store.commit('searchStore/SET_OTHER_MODAL', {
        name: 'modalKbliFilter',
        status: true,
      })
    },
    async resetFilter() {
      await this.$store.commit('level1/SET_STATUS_CATEGORY')
      await this.$store.commit('searchStore/RESET_FILTER')
      await this.$store.commit('level1/RESET_QUERY')

      await this.$store.commit('level1/SET_DATA_LEVEL1')
    },
    async showModal(id) {
      await this.$store.commit('modalStore/SET_MODAL_LEVEL1', true)
      await this.$store.commit('level1/GET_PROFILE_DATA', { id })
    },
    closeModal() {
      this.$store.commit('modalStore/SET_MODAL_LEVEL1', false)
    },
    k3lRiskCategory(score) {
      if (score && score > 0) {
        if (score <= 24) return 'LOW C2'
        if (score > 24 && score < 35) return 'LOW C1'
        if (score >= 35 && score < 50) return 'MEDIUM B2'
        if (score >= 50 && score < 70) return 'MEDIUM B1'
        if (score >= 70 && score <= 100) return 'HIGH'
      }
      return '-'
    },
    poTerbanyak() {
      this.$store.commit(
        'level1/LEVEL1_ORDER_BY',
        '&order_by=total_po&order_short=desc'
      )
    },
    eventTerbanyak() {
      this.$store.commit(
        'level1/LEVEL1_ORDER_BY',
        '&order_by=total_event&order_short=desc'
      )
    },
    level1Terbaru() {
      this.$store.commit(
        'level1/LEVEL1_ORDER_BY',
        '&order_by=createdAt&order_short=desc'
      )
    },
    async getK3lCriteria() {
      try {
        const urlK3l = `${api}/api/v1/k3l-categories?page=1&limit=3`

        const { data: k3l } = await axios({
          method: 'GET',
          url: urlK3l,
        })

        this.k3lCategories = k3l.data

        if (this.k3lCategories) {
          return true
        }

        return false
      } catch (error) {
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async getKplhCriteria() {
      try {
        const urlKplh = `${api}/api/v1/kplh-categories?page=1&limit=4`

        const { data: kplh } = await axios({
          method: 'GET',
          url: urlKplh,
        })

        this.kplhCategories = kplh.data

        if (this.kplhCategories) {
          return true
        }

        return false
      } catch (error) {
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    getK3lCategories(value) {
      const categories = this.k3lCategories
      if (value && value > 0) {
        if (categories) {
          for (let i in categories) {
            if (
              categories[i].score_min <= value &&
              categories[i].score_max >= value
            )
              return categories[i].desc
          }
        }
      }

      return ''
    },
    getKplhCategories(value) {
      const categories = this.kplhCategories
      if (value && value > 0) {
        if (categories) {
          for (let i in categories) {
            if (
              categories[i].score_min <= value &&
              categories[i].score_max >= value
            )
              return categories[i].desc
          }
        }
      }

      return ''
    },
  },
}
</script>
